import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import FlagIcon from "@root/assets/icons/flag-icon";

export interface RestartTourButtonProps {
  onClick: () => void;
  bottom?: string;
  right?: string;
  left?: string;
  top?: string;
  position?: "fixed" | "absolute" | "relative" | "static";
  zIndex?: number;
}

export const RestartTourButton: React.FC<RestartTourButtonProps> = ({
  onClick,
  bottom = "30px",
  right = "30px",
  left,
  top,
  position = "fixed",
  zIndex = 1000,
}) => {
  const { t } = useTranslation("common");

  return (
    <Box
      position={position}
      bottom={bottom}
      right={right}
      left={left}
      top={top}
      zIndex={zIndex}
      cursor="pointer"
      onClick={onClick}
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="8px"
      _hover={{
        transform: "scale(1.05)",
        transition: "transform 0.2s",
      }}
    >
      {/* Circular Icon with Flag */}
      <Box
        width="48px"
        height="48px"
        borderRadius="50%"
        bg="#E5E5E5"
        display="flex"
        alignItems="center"
        justifyContent="center"
        boxShadow="0px 2px 8px rgba(0, 0, 0, 0.1)"
      >
        <FlagIcon width={18} height={22} color="#1A1A1A" />
      </Box>
      {/* Text */}
      <Text fontSize="12px" fontWeight="500" color="#1A1A1A" textAlign="center">
        {t("tourGuide.restartTour") || "Restart Tour"}
      </Text>
    </Box>
  );
};
